module.exports = __webpack_public_path__ + "static/media/Freddy-Jumpscare1.09936815.gif";